// MobileMFA.jsx
import React, { useState } from 'react';
import './mobile.css'; 

import { verifyMFAOTP } from "../../utils/mfaUtils";

const MobileMFA = ({ email, loginToken, onSuccess }) => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [verifying, setVerifying] = useState(false);

    const verifyOTP = async (otpValue) => {
        setVerifying(true);
        setError('');
        try {
            await verifyMFAOTP(email, otpValue, loginToken, onSuccess, (errorMessage) => {
                setError(errorMessage);
            });
        } catch (err) {
            // Error is already handled in verifyMFAOTP utility function
            setError("Invalid OTP. Please try again.");
        } finally {
            setVerifying(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        const otpValue = otp.trim();
        if (otpValue.length !== 6) {
            setError('Please enter a valid 6-digit code.');
            return;
        }
        
        verifyOTP(otpValue);
    };

    // Note: This component is only used for OTP verification on mobile.
    // MFA setup (QR code) is not allowed on mobile and is handled by the parent logic.
    
    return (
        <div className="login-container">
            <div className="top-content-wrapper">
                <p className="title-mobile">Two-Factor Authentication</p>
                <p className="tagline">
                    Enter the code generated by your Authenticator app.
                </p>
                <p className="instruction-text">
                    Verifying login for: {email}
                </p>

                <form onSubmit={handleSubmit} className="login-form">
                    <input
                        type="tel"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value.slice(0, 6))}
                        className="input-field"
                        placeholder="Enter 6-digit Code"
                        maxLength="6"
                        disabled={verifying}
                    />

                    {error && <p className="error-message">{error}</p>}

                    <button
                        type="submit"
                        className="login-button"
                        disabled={verifying}
                    >
                        {verifying ? "Verifying..." : "Verify Code"}
                    </button>
                </form>
            </div>

           
            
            <p className="footer-text-login">v1.2.0 • Powered by ElhiTech</p>
        </div>
    );
};

export default MobileMFA;